import axios from "axios";
import { useEffect, useState } from "react";
import { AiFillPlusCircle } from "react-icons/ai";
import { useNavigate } from "react-router";
import Actions from "../../../components/Common/Actions";
import CommonFilterModal from "../../../components/Common/CommonFilterModal";
import DoctorsFilterOptions from "../../../components/Common/CommonFilterOptions";
import NavBarTitles from "../../../components/Common/TabBar";
import ListPageLayout from "../../../components/Layout";
import Deletepopup from "../../../components/Modal/Deletepopup";
import useDebouncedSearch from "../../../components/Utils/hooks/useDebouncedSearch";
import useDeleteHandler from "../../../components/Utils/hooks/useDeleteHandler";
import usePageChange from "../../../components/Utils/hooks/usePageChange";
import usePaginatedData from "../../../components/Utils/hooks/usePaginatedData";
import useSortHandler from "../../../components/Utils/hooks/useSortHandler";
import { statuses } from "../../../Pages/Masters/Utils/MasterConst";
import { careernavBarData, DepartmentBreadcrumbs } from "../const";

const Department = () => {
  const navigate = useNavigate();

  // Sorting
  const [sort, setSort] = useState("");
  const [sortName, setSortName] = useState("Newest First");
  const handleSortClick = useSortHandler(setSort, setSortName);

  // Search
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebouncedSearch(setSearch, () =>
    setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 }))
  );

  // Filter states
  const [selectedValues, setSelectedValues] = useState({
    Department: [],
    Designation: [],
    Status: [],
  });

  const [tempSelectedValues, setTempSelectedValues] = useState({
    Department: [],
    Designation: [],
    Status: [],
  });

  const [selectedCategory, setSelectedCategory] = useState("Department");
  const [isFilterModalVisible, setIsFilterModalVisible] = useState(false);

  // Delete state
  const [deleteId, setDeleteId] = useState("");
  const [showDelete, setShowDelete] = useState(false);
  const [loader, setLoader] = useState(true);
  // Pagination
  const { records, totalCount, pagination, setPagination, fetchData } =
    usePaginatedData({
      apiUrl: `${process.env.REACT_APP_API_URL}career-add-department/list`,
      initialParams: {
        sort,
        searchText: search,
        selectedValues,
      },
    });

  const handlePageChange = usePageChange(pagination, setPagination);
  const handleDelete = useDeleteHandler(
    "career-add-department",
    fetchData,
    setShowDelete
  );

  const handleEdit = (id) => {
    navigate(`/careerDepartmentEdit/${id}`);
  };

  const handleActive = (id, status) => {
    setLoader(true)
    axios
      .patch(
        `${process.env.REACT_APP_API_URL}career-add-department/update/${id}`,
        {
          active: !status,
        }
      )
      .then((result) => {
        fetchData();
      });
  };

  useEffect(() => {
    setLoader(true)
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.skip, pagination.limit, sort, search, selectedValues]);

  const columns = [
    {
      title: "S.No",
      dataIndex: "serial",
      key: "serial",
      render: (text, record, index) => Number(pagination.skip) + (index + 1),
      width: 80,
    },
    {
      title: "Department / Function Name",
      dataIndex: "department",
      key: "department",
      width: 290,
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Actions
          recordActiveStatus={record.active}
          isActive={true}
          onClickActive={() => handleActive(record._id, record.active)}
          isEdit={true}
          isDelete={true}
          onClickDelete={() => {
            setDeleteId(record._id);
            setShowDelete(true);
          }}
          onClickEdit={() => handleEdit(record._id)}
        />
      ),
    },
  ];

  const dataSource = records
    ?.filter((el) => el.show === undefined || el.show === true)
    .map((el) => ({
      key: el._id,
      _id: el._id,
      department: el.department,
      functionName2: el.functionName2,
      active: el.active,
    }));

  const filters = {
    Department: ["Engineering", "Sales", "Content", "Back Office Operations"],

    Status: statuses,
  };
  useEffect(() => {
    records && setTimeout(() => setLoader(false));
  }, [records]);

  return (
    <ListPageLayout
      breadcrumbs={<DepartmentBreadcrumbs />}
      addButton={
        <div
          id="addnewpost"
          onClick={() => navigate("/departmentFunctionForm")}
          className="addnewhealth"
          style={{ width: "240px" }}
        >
          <div>
            <AiFillPlusCircle color="#4E91C2" size={25} />
          </div>
          <div>
            <button className="text-nowrap">Add Department/Function</button>
          </div>
        </div>
      }
      titles={<NavBarTitles titles={careernavBarData} />}
      filters={
        <DoctorsFilterOptions
          limit={pagination.limit}
          setLimit={(val) =>
            setPagination((prev) => ({
              ...prev,
              limit: val,
              skip: 0,
              currentPage: 1,
            }))
          }
          search={search}
          onChange={debouncedSearch}
          handleSortClick={handleSortClick}
          sortName={sortName}
          filter_records={() => {}}
          setFilterShow={() => setIsFilterModalVisible(true)}
        />
      }
      tableProps={{
        columns,
        dataSource,
      }}
      totalCount={totalCount}
      pagination={pagination}
      onPageChange={(selected) => handlePageChange({ selected })}
      loader={loader}
    >
      {/* Optional children like modals */}
      {showDelete && (
        <Deletepopup
          handleDelete={() => handleDelete(deleteId)}
          id={deleteId}
          handleClose={() => setShowDelete(false)}
        />
      )}

      <CommonFilterModal
        visible={isFilterModalVisible}
        onClose={() => setIsFilterModalVisible(false)}
        onApply={() => {
          setSelectedValues(tempSelectedValues);
          setIsFilterModalVisible(false);
          setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 }));
          fetchData();
        }}
        onReset={() => {
          setTempSelectedValues({
            Department: [],
            Designation: [],
            Status: [],
          });
          setSelectedValues({
            Department: [],
            Designation: [],
            Status: [],
          });
          setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 }));
          fetchData();
        }}
        filters={filters}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        selectedValues={tempSelectedValues}
        setSelectedValues={setTempSelectedValues}
      />
    </ListPageLayout>
  );
};

export default Department;
